// extracted by mini-css-extract-plugin
module.exports = {"UserTable":"UsersTable__-lcoal-__3584f","TableWrapper":"UsersTable__-lcoal-__2d03i","TableHead":"UsersTable__-lcoal-__1POep","checkIcon":"UsersTable__-lcoal-__15Eet"};